var __rspack_ns_object = JSON.parse('{"No results.":"No results.","Not enough room to display this column":"Not enough room to display this column"}')